export default __webpack_public_path__ + "static/media/business-card-icon.eb935dc6.svg";